<template>
  
 <div >
  
  <b-overlay :show="false" rounded="sm" z-index="1001"></b-overlay>
   
 
    <!--<div style="position:absolute;top:80px;z-index:1001"> 
      <b-button  squared class="btn btn-color-sidebar btn-settings" v-b-toggle.sidebar-2 ><i class="fa-solid fa-layer-group"></i></b-button>
    </div>-->
    
    <b-sidebar  left title="ΠεΣΠΚΑ"  v-model="sidebar_settings" @change="setsidebarMap" id="sidebar-2" width="400px" bg-variant="dark" text-variant="light" >
     
      <template #header="{hide}">
        
        <div class="d-flex w-100 justify-content-between align-items-center"> 
          <p style="font-size: 1px;">`</p>
          <img src="/img/logo.jpg" style="width:35%;border-radius: 20px;"/>
         
       <div @click="hide" style="cursor: pointer;color:red;font-size: 20px;">x</div>
      </div>
     
      </template>
      <div class="py-5 text-center">
        Κατηγοριοποίηση Ακινήτων:
        <b-form-select v-model="selected_radio_group" class="mb-3">
          <!-- This slot appears above the options from 'options' prop -->
          
          <template #first>
            <b-form-select-option :value="null">-- Please select an option --</b-form-select-option>
          </template>

          <!-- These options will appear after the ones from 'options' prop -->
          <b-form-select-option v-for="(hh,index) in options_radio_group" :value="hh.value" :key="index+'select'">{{hh.text}}</b-form-select-option>
        
        </b-form-select>


      </div>
      
      <template v-slot:footer>
        <div class="text-center">
          <b-button v-b-modal.modal-profile class="mb-3" variant="primary" block >Profile<i class="fa-solid fa-user pl-2"></i></b-button>
        </div> 

        <b-modal id="modal-profile" title=""  hide-footer size="xl">
          <Profile />
        </b-modal>
        <div class="text-center">
          <b-button class="mb-3" variant="danger" block @click="Logout">Logout<i class="fa-solid fa-right-from-bracket pl-2"></i></b-button>
        </div>  
            <!--<div class="row justify-content-center align-items-center bg-white m-2 p-2 shadow" style="margin-right: 0px;margin-left: 0px;border-radius: 10px;">
              <div class="col-12 text-dark text-center">Ανάπτυξη εφαρμογής</div>
              <div class="col-4">
                <a href="https://www.adens.gr/" target="_blank"><img src="/img/logo_adens.png" style="width:100%"/></a>
              </div>
              <div class="col-4">
                <a href="http://apcg.meteo.noa.gr/" target="_blank"><img src="/img/apcg-logo.png" style="width:100%"/></a>
              </div>
              <div class="col-4">
                <a href="https://idcom.gr" target="_blank"><img src="/img/idcom-fav.png" style="width:100%"/></a>
              </div>
            </div>
            <div class="m-2">
              <img src="/img/footer-768x115.png" style="border-radius: 10px;width:100%" />
            </div>-->

      </template>

  
    </b-sidebar>
    
    <b-modal id="modal-genika-arxia" title="" hide-footer size="xl" class="p-0">
      
      <b-tabs content-class="h-100" class="h-100">
        <b-tab title="Ανάλυση Ακίνητης Περιουσίας" active class="h-100"><iframe width="100%" style="height:100%" :src="'https://metabase.systemsdynamics.ddns.net/public/dashboard/da73fb22-ac31-4616-837a-de2cdabe9d01'"></iframe></b-tab>
       
        
      </b-tabs>
    </b-modal>
    <div class="d-flex">
      
    
      <div slot="firstPane" class="w-100" style="height: 100vh;" >
          <l-map class="" style="height:100%;" :options="{attributionControl: false, zoomControl: false,maxZoom: 100}" :zoom="zoom" :center="center" ref="map1" @update:zoom="zoomUpdate">
            <l-control-zoom position="topright"  ></l-control-zoom>
      <!--<l-tile-layer :url="url"></l-tile-layer>-->
      <l-control-layers position="topright"></l-control-layers>
      <l-control position="topleft">
        <div class="p-2" style="background-color: #fff;border-radius: 20px;"><img src="/img/logo.jpg" alt="" style="width:70px;" ></div>
      </l-control>
      <l-control position="bottomleft">
        <div class="p-2" style="background-color: #fff;border-radius: 15px;"><a href="https://www.lesd.gr/" target="_blank"><img src="/img/SYSTEM-DYNAMICS-logo-3.png" alt="" style="width:60px;" ></a></div>
      </l-control>
      <l-control position="topleft" >
        <div class="p-0" title="Κατηγοριοποίηση Ακινήτων"><i class="fa-solid fa-filter p-2" style="font-size:20px"  v-b-toggle.sidebar-2 ></i> </div>
      </l-control>
      <l-control position="topleft" >
        <div class="p-0" @click="show_table=!show_table"><i class="fa-solid fa-table p-2"  style="font-size:20px"></i> </div>
      </l-control>
      <!--<l-control position="topleft" >
        <div class="p-0" title="Γενικά αρχεία" v-b-modal.modal-genika-arxia><i class="fa-solid fa-file-pdf p-2" style="font-size:25px"></i> </div>
      </l-control> -->
      <l-control position="topleft" >
        <div class="p-1" title="Στατιστικά" v-b-modal.modal-genika-arxia>
          <img src="/img/metabase.svg" style="width: 28px;"  /></div>
      </l-control> 

     
        <l-tile-layer
                      v-for="tileProvider in tileProviders"
                      :key="tileProvider.name"
                      :name="tileProvider.name"
                      :visible="tileProvider.visible"
                      :url="tileProvider.url"
                      :attribution="tileProvider.attribution"
                      layer-type="base"
                      :options="{ maxNativeZoom: 18, maxZoom: 100 }"
                    
        />
        <l-tile-layer            
          :url="'https://cemeteryzak.systemsdynamics.ddns.net/tiles_cemetery/{z}/{x}/{y}.png'"
          :zIndex="1001" 
          :options="{ maxNativeZoom: 26, maxZoom: 100 }"
        />
    
      
                
      <!--<v-geosearch :options="geosearchOptions"></v-geosearch>-->
      <l-control position="topright" :disableScrollPropagation="true">
       
        <div @click="show_control_search=!show_control_search" style="width: 25px;height: 25px;" class="d-flex justify-content-center align-items-center">
          <i class="fa-solid fa-magnifying-glass" style="font-size:20px;"></i>
          <i v-if="show_control_search" class="fa-solid fa-xmark"></i>
        </div>
        <b-form-input v-if="show_control_search" v-model="search_value" placeholder="Enter id" @update="change_search"></b-form-input>
        <div v-if="show_control_search && searchResults.length>0 && search_value!=='' ">
          <div style="max-width: 300px;max-height: 100px;overflow-y: scroll;">
            <li v-for="(tt,index) in searchResults" :key="index+'results'" @click="flyToMarker(tt)">{{tt.ids}} ({{ tt.cemet_name }})</li>
          </div>
        </div>
      </l-control>
      <v-locatecontrol   :options="{position:'topright'}"/>
      <l-control position="topright" >
        <div @click="show_controls=!show_controls" style="width: 25px;height: 25px;" class="d-flex justify-content-center align-items-center"><i class="fa-solid fa-chevron-down" style="font-size:20px;"></i></div>
        
      </l-control>
      <l-control-polyline-measure
        v-if="show_controls"
        :options="{
          showUnitControl: true,
          showClearControl: true,
          clearMeasurementsOnStop: false,
          }"
        position="topright"
        />
        <l-control-scale
        v-if="show_controls"
                    position="topright"
                    :imperial="true"
                    :metric="true"
        ></l-control-scale>
      <!--<l-wms-tile-layer
                      :base-url="'https://geoserver.idcom.gr/geoserver/perifereia/wms'"
                      :layers="'perifereia:geodata_dimoi_attikis_kallikratis'"
                      :transparent="true"
                      format="image/png"
                      :zIndex="7"
                      :opacity="1"
                    >
      </l-wms-tile-layer>
    37.98750437106374; // Replace with your minimum latitude
    const maxLat = 38.136716904135376; // Replace with your maximum latitude
    const minLng = 23.36105346679688; // Replace with your minimum longitude
    const maxLng = 23.68034362792969;
    --> 
   
    <div v-if="cemeteries_points && live_zoom<=19" >
          <l-geo-json   
                :geojson="cemeteries_points"
                :options="{ pointToLayer: pointToLayer,onEachFeature:optionsPoints}"
          ></l-geo-json>
    </div>
    
    
    <ParcelsPoly  ref="parcelsPoly"  :live_zoom="live_zoom" :ref_map="$refs.map1" :selected_radio_group="selected_radio_group"  v-if="live_zoom>17"></ParcelsPoly>
     
     
    </l-map>


    <!--<div class="legend-div" style="" v-if="current_legend">
        <div class="card shadow" style="border-radius: 20px;">
          <div class="card-body">
            <legendControl :data="current_legend"></legendControl>        
          </div>
        </div>
      </div>-->
      <div v-if="cemeteries_points && show_table" class="p-3" style="position: absolute;bottom:0;left:0;width:400px; z-index: 1002;">
        <div class="p-2" style="background-color: #fff;border-radius: 15px;">
          <div class="d-flex justify-content-end"><b-button size="sm" variant="danger" @click="show_table=false">x</b-button> </div>
          <b-table bordered small sticky-header striped hover :items="cemeteries_points_table" :fields="table_fields" style="font-size: 12px;" @row-clicked="tableToMarker">
            <template #cell()="data">
                      
                      <div v-if="data.value !== '' && data.value !== false && data.value !== true">{{ data.value }}</div>
                      <div v-if="data.value===''">-</div>
                    </template>
          </b-table>
        </div>
      </div>
     
      <div style="position: absolute;bottom:20px;right:20px; z-index: 1001;" v-if="selected_radio_group">
       <legendControl :data="options_radio_group" ></legendControl>
      </div>
     
     
        
      </div>
    </div>
 </div>
</template>


<script>
//import L from "leaflet";
import * as L from "leaflet";
import "leaflet-geotiff";
import '../js/leaflet.geometryutil.js'
import '../js/leaflet-arrowheads.js'
import axios_django from "../axios-auth";
import axios_all from "axios";
//import VJstree from "vue-jstree";
import LControlPolylineMeasure from "vue2-leaflet-polyline-measure";
//import axios from 'axios'
//import VueSlider from 'vue-slider-component/dist-css/vue-slider-component.umd.min.js'
import 'vue-slider-component/dist-css/vue-slider-component.css'
import 'vue-slider-component/theme/default.css'
//import legend_data from '../../public/json/legend_data.json'
import table_columns from '../json/table_columns.json'
//import filter_columns from '../json/filter_columns.json'
import tabs_info from '../json/tabs.json'
import info_popup from '../json/info_popup.json'
import legendControl from './legendBari.vue'
//import legendForSLD from './legendForSLD.vue'
//import polyVertices from './Poly_Vertices.vue'
import ParcelsPoly from './Parcels_Poly.vue'
import Profile from './Profile.vue'

//import VGeosearch from 'vue2-leaflet-geosearch';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import Vue2LeafletLocatecontrol from 'vue2-leaflet-locatecontrol'
//import ResSplitPane from 'vue-resize-split-pane'
import "../js/L.Map.Sync.js";
import "../js/leaflet.sld.js";
import "../js/leaflet-polygon.fillPattern.js";
import { QGISStyleParser } from 'geostyler-qgis-parser';
//import {Draggable } from "vue-smooth-dnd";
//import { applyDrag } from "../utils";

export default {
  components: {
    //VueSlider,
    //VJstree,
    //'rs-panes':ResSplitPane,
    legendControl,
    "l-control-polyline-measure": LControlPolylineMeasure,
    //VGeosearch,
    'v-locatecontrol': Vue2LeafletLocatecontrol,
    //Container, 
    //Draggable,
    //polyVertices,
    ParcelsPoly,
    Profile,
    //legendForSLD
  },
  data() {
    return {
      line_style:null,

      arrowheads_pipe:null,
      SLD_Styler:null,
      show_diktia_ydreusis:false,
      cemeteries_points:null,
      cemeteries_points_table:null,
      sld_style:null,
      pointToLayer_style:null,
      diktia_ydreusis_pipe:null,
      visible_tabs:true,
      show_tabs:false,
      show_diktia_ydreusis_tabs:false,
      file_list:null,
      selected_file:null,
      station_clicked:null,
      diktia_ydreusis_station_clicked:null,
      tabs_info:tabs_info,
      info_popup:info_popup,
      orderSelected:[],
      show_table:false,
      tst:false,
      search_value:'',
      searchResults:[],
      show_control_search:false,
      show_controls:false,
      poi_data:null,
      poly_vertices:null,
      table_columns:table_columns,
      sidebar_settings:this.$store.state.sidebarMap,

      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      stationsAllData:null,
      zoom: 9,
      center: [37.77384340624945, 20.872762347234783],
      tileProviders: [
        {
          name: "OpenStreetMap",
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        },
        {
          name: "OpenStreetMap.HOT",
          visible: false,
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>',
          url: "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
        },

        {
          name: "OpenTopoMap",
          visible: false,
          url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
          attribution:
            'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          name: "Stadia.AlidadeSmoothDark",
          visible: false,
          url: "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png?api_key=9a9206be-79a9-461b-986f-f9b419cdb7ea",
          attribution:
            '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
        },
        {
          name: "CyclOSM",
          visible: false,
          url: "https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
          attribution:
            '<a href="https://github.com/cyclosm/cyclosm-cartocss-style/releases" title="CyclOSM - Open Bicycle render">CyclOSM</a> | Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        },
        {
          name: "Esri.WorldImagery",
          visible: true,
          url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
          //url: "http://gis.ktimanet.gr/wms/wmsopen/wmsserver.aspx",
          attribution:
            "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
        
        },
        
      ],
      geosearchOptions: { // Important part Here
        provider: new OpenStreetMapProvider(),
        style: 'button',
        position:'topright'
      },
      table_fields:[],
      selected_radio_group:null,
      options_radio_group:[
      ],
      live_zoom:9,
      file_list_fields:[
                  {
                      "label":"Κωδικός Εγγράφου",
                      "key":"iddoc"
                  },
                  {
                      "label":"Κωδικός Συστήματος Ακινήτου",
                      "key":"ids"
                  },
                  {
                      "label":"Προσωρινός Κωδικός",
                      "key":"proptempid"
                  },
                  {
                      "label":"αρ. πρωτοκόλλου",
                      "key":"docprot"
                  },
                  {
                      "label":"Τίτλος Εγγράφου",
                      "key":"doctitle"
                  },
                  {
                      "label":"Αριθμός Εγγράφου",
                      "key":"docnum"
                  },
                  {
                      "label":"Ονοματεπώνυμο προσώπου που επικυρώνει",
                      "key":"doctype"
                  },
                  {
                      "label":"Ιδιότητα προσώπου που επικυρώνει",
                      "key":"docepname"
                  },
                  {
                      "label":"Θέση προσώπου που επικυρώνει",
                      "key":"docepprof"
                  },
                  {
                      "label":"Οργανισμός που επικυρώνει",
                      "key":"doceporg"
                  },
                  {
                      "label":"Ημερομηνία εγγράφου",
                      "key":"docdate"
                  },
                  {
                      "label":"Ονομασία αρχείου εγγράφου",
                      "key":"docfilename"
                  },
                  /*{
                      "label":"το έγγραφο αφορά σε πειουσιακό στοιχείο εκτός περιουσίας",
                      "key":"noproperty"
                  },*/
                  {
                      "label":"ονομασία φακέλου αρχείου φορέα",
                      "key":"archfold"
                  }
      ]
    }
  },
  computed:{
    optionsPoints() {
      return this.onEachFeaturePoints;
    },
    onEachFeaturePoints(){
     // console.log('onEachFeaturePoints')
      var v = this;
      // eslint-disable-next-line no-unused-vars
      
      return (feature, layer) => {
      
        layer.bindPopup((e)=>{
          console.log(e.feature.properties)
          var table=``
          //console.log(v.diktia_ydreusis_json)
          var fields=v.info_popup[1].fields
          for(var gg=0; gg<fields.length; gg++){
              table=table+`
                <tr>
                  <td>${fields[gg].label}</td>
                  
                  
                  <td>${e.feature.properties[fields[gg].key]!==null ? e.feature.properties[fields[gg].key]: '-' }</td>
                      
                </tr>
              `
          }
          //console.log(table)
            const div = document.createElement("div");
            div.innerHTML = `<h6 class="text-center">Πληροφορίες Νεκροταφείου</h6>`;
           
           // Creating table element
            const table_div = document.createElement("table");
            table_div.setAttribute("class", "table table-bordered table-sm table-responsive");
            table_div.setAttribute("style", "max-height: 350px; min-width: 145px;");
            const tbody = document.createElement("tbody");
            tbody.innerHTML = `${table}`;
            table_div.appendChild(tbody);
            div.appendChild(table_div);
          return  div

           
        })
       
        
          
      }
 
   
    },
  
  },
  mounted(){
    this.$nextTick(() => {
      
     // this.loadGeoTIFF();
     
      
    })
    this.$nextTick(() => {
  
      //this.$refs.map1.mapObject.sync(this.$refs.map2.mapObject)
      //this.$refs.map2.mapObject.sync(this.$refs.map1.mapObject)
    });
  },
  async created(){
   
    this.loadchurch()
    //this.loadPolyVertices()
    for(var gg=0; gg<this.table_columns.length; gg++){
      this.table_fields.push({
        key: this.table_columns[gg].value,
        label: this.table_columns[gg].text,
        //sortable: true,
      })
    }
    console.log(this.table_fields)

    this.getDiktioYdreusis()
    

  
  },
  methods:{
    loadGeoTIFF() {
      const map = this.$refs.map1.mapObject; // Get the Leaflet map instance
      const geotiffUrl = "https://stuartmatthews.github.io/leaflet-geotiff/tif/wind_speed.tif";
      //const geotiffUrl = "http://localhost:8080/img/00040_5cm_high_com_epsg4326.tif";
      const options = {
        // See renderer sections below.
        // One of: L.LeafletGeotiff.rgb, L.LeafletGeotiff.plotty, L.LeafletGeotiff.vectorArrows
        renderer: null,

        // Use a worker thread for some initial compute (recommended for larger datasets)
        useWorker: false,

        // Optional array specifying the corners of the data, e.g. [[40.712216, -74.22655], [40.773941, -74.12544]].
        // If omitted the image bounds will be read from the geoTIFF file (ModelTiepoint).
        bounds: [],

        // Optional geoTIFF band to read
        band: 0,

        // Optional geoTIFF image to read
        image: 0,

        // Optional clipping polygon, provided as an array of [lat,lon] coordinates.
        // Note that this is the Leaflet [lat,lon] convention, not geoJSON [lon,lat].
        clip: undefined,

        // Optional leaflet pane to add the layer.
        pane: "overlayPane",

        // Optional callback to handle failed URL request or parsing of tif
        onError: null,

        // Optional, override default GeoTIFF function used to load source data
        // Oneof: fromUrl, fromBlob, fromArrayBuffer
        //sourceFunction: GeoTIFF.fromUrl,

        // Only required if sourceFunction is GeoTIFF.fromArrayBuffer
        arrayBuffer: null,

        // Optional nodata value (integer)
        // (to be ignored by getValueAtLatLng)
        noDataValue: undefined,

        // Optional key to extract nodata value from GeoTIFFImage
        // nested keys can be provided in dot notation, e.g. foo.bar.baz
        // (to be ignored by getValueAtLatLng)
        // this overrides noDataValue, the nodata value should be an integer
        noDataKey: undefined,

        // The block size to use for buffer
        blockSize: 65536,

        // Optional, override default opacity of 1 on the image added to the map
        opacity: 1,

        // Optional, hide imagery while map is moving (may prevent 'flickering' in some browsers)
        clearBeforeMove: false,
      };
      const layer = L.leafletGeotiff(geotiffUrl,options);
      layer.addTo(map); // Add the layer to the map
    },
    pointToLayer(feature, latlng) {
      // Define the custom icon
      const icon = L.icon({
        iconUrl: '/img/icons8-solar-cross-100_2.png', // Replace with your actual PNG file path
        iconSize: [20, 20], // Customize the icon size
        iconAnchor: [16, 20], // Anchor the icon (half-width, full height)
        popupAnchor: [0, -20] // Position of the popup relative to the icon
      });

      // Create and return a marker with the custom icon
      return L.marker(latlng, { icon });
    },
    openTautotitaDikti(e){
        var v=this
        console.log(e)
        v.diktia_ydreusis_station_clicked=[e.feature.properties]
        v.show_diktia_ydreusis_tabs=true
        v.visible_tabs=true
        
      },
   
    string_to_slug(str) {

    str  = str.replace(/^\s+|\s+$/g, '') // TRIM WHITESPACE AT BOTH ENDS.
            .toLowerCase();            // CONVERT TO LOWERCASE

    const from = [ "ου", "ΟΥ", "Ού", "ού", "αυ", "ΑΥ", "Αύ", "αύ", "ευ", "ΕΥ", "Εύ", "εύ", "α", "Α", "ά", "Ά", "β", "Β", "γ", "Γ", "δ", "Δ", "ε", "Ε", "έ", "Έ", "ζ", "Ζ", "η", "Η", "ή", "Ή", "θ", "Θ", "ι", "Ι", "ί", "Ί", "ϊ", "ΐ", "Ϊ", "κ", "Κ", "λ", "Λ", "μ", "Μ", "ν", "Ν", "ξ", "Ξ", "ο", "Ο", "ό", "Ό", "π", "Π", "ρ", "Ρ", "σ", "Σ", "ς", "τ", "Τ", "υ", "Υ", "ύ", "Ύ", "ϋ", "ΰ", "Ϋ", "φ", "Φ", "χ", "Χ", "ψ", "Ψ", "ω", "Ω", "ώ", "Ώ" ];
    const to   = [ "ou", "ou", "ou", "ou", "au", "au", "au", "au", "eu", "eu", "eu", "eu", "a", "a", "a", "a", "b", "b", "g", "g", "d", "d", "e", "e", "e", "e", "z", "z", "i", "i", "i", "i", "th", "th", "i", "i", "i", "i", "i", "i", "i", "k", "k", "l", "l", "m", "m", "n", "n", "ks", "ks", "o", "o", "o", "o", "p", "p", "r", "r", "s", "s", "s", "t", "t", "y", "y", "y", "y", "y", "y", "y", "f", "f", "x", "x", "ps", "ps", "o", "o", "o", "o" ];

    for ( var i = 0; i < from.length; i++ ) {

      while( str.indexOf( from[i]) !== -1 ){

          str = str.replace( from[i], to[i] );    // CONVERT GREEK CHARACTERS TO LATIN LETTERS

      }

    }

    str = str.replace(/[^a-z0-9 -]/g, '') // REMOVE INVALID CHARS
            .replace(/\s+/g, '-')        // COLLAPSE WHITESPACE AND REPLACE BY DASH - 
            .replace(/-+/g, '-');        // COLLAPSE DASHES

    return str;

    },
    openTautotita(station){
      this.markerClick(station)
      this.show_tabs=true
      this.visible_tabs=true
    },
    changeSelectedFile(){
    
      console.log(this.file_list[this.selected_file])

    },
    markerClick(station){
      this.station_clicked=[station]
      console.log(this.station_clicked)
      var token=localStorage.getItem('token')
      axios_django.get('cemeteryzak/file_list/',{params:{ids:this.station_clicked[0].ids},headers: {Authorization: `Bearer ${token}`}}).then(res=>{
        console.log(res.data)
        this.file_list=res.data
      })

      this.show_tabs=false
    },  
    loadPolyVertices(){
      var token=localStorage.getItem('token')
      axios_django.get('cemeteryzak/poly_vetrices/',{headers: {Authorization: `Bearer ${token}`}}).then(res=>{
        this.poly_vertices=res.data
        console.log(this.poly_vertices)
      })
    },
    getDiktioYdreusis(){
      var token=localStorage.getItem('token')
    
      axios_django.get('cemeteryzak/diktia_ydreusis/',{headers: {Authorization: `Bearer ${token}`}}).then(async (res)=>{
        console.log(res.data)
        
        
        this.cemeteries_points={type: 'FeatureCollection',features: [],}
        this.cemeteries_points_table=res.data.points

        for(var gg=0; gg<res.data['points'].length; gg++){
          this.cemeteries_points.features.push({
                  type: 'Feature',
                  geometry:JSON.parse(res.data['points'][gg].geom),
                  properties: res.data['points'][gg],
                },)
        }

        console.log(this.cemeteries_points)
        console.log(this.cemeteries_points_table)
   
      })
    },
    qmlToStyle(e){
      //console.log(this.line_style)
      //console.log(e.properties.mtype)
      var flow= e.properties.flow==null ? "\"flow\" IS NULL" : e.properties.flow
      let foundObject = this.line_style.find(obj => obj.label === e.properties.mtype && obj.filter.includes(flow)  )
      
      var json_style={color: 'rgba('+foundObject.symbol.color+')'}
      //console.log(json_style)
      return  json_style
      
    },
   
    async loadchurch(){
 
      this.orderSelected=[]
      this.selected_radio_group=null
      this.options_radio_group=[]
      var filter_columns=await axios_all.get('/json/filter_columns.json')
      filter_columns=filter_columns.data
      var obj=[]
      obj=filter_columns
      this.options_radio_group=obj
      this.selected_radio_group=obj[0].value
      
    },
    sldStyle(sld) {
      var sldObject = (new DOMParser()).parseFromString(sld, "text/xml");
      return function(feature) {
        // Default style if no matching rule found
        let defaultStyle = {
          fillColor: '#ff0000',
          color: '#000000',
          radius: 6
        };
        //console.log(sldObject)
    
        const rules = sldObject.getElementsByTagName('se:Rule');
        for (let i = 0; i < rules.length; i++) {
          const rule = rules[i];
          //console.log(rule)
          if (rule.childNodes.length === 0) continue; // Skip empty rules
          const filter = rule.getElementsByTagName('ogc:Filter')[0];
          //console.log(filter)
          if (!filter) continue; 
          const propertyIsEqualTo = filter.getElementsByTagName('ogc:PropertyIsEqualTo')[0];
          const literal = propertyIsEqualTo.getElementsByTagName('ogc:Literal')[0];
          const typeName = literal.textContent;
          
          if (feature.properties.type === typeName) {
            const pointSymbolizers = rule.getElementsByTagName('se:PointSymbolizer');
            for (let j = 0; j < pointSymbolizers.length; j++) {
              const pointSymbolizer = pointSymbolizers[j];
              const wellKnownName = pointSymbolizer.getElementsByTagName('se:WellKnownName')[0].textContent;
              const fill = pointSymbolizer.getElementsByTagName('se:Fill')[0];
              const stroke = pointSymbolizer.getElementsByTagName('se:Stroke')[0];
              const svgParameterFill = fill.getElementsByTagName('se:SvgParameter')[0];
              const svgParameterStroke = stroke.getElementsByTagName('se:SvgParameter')[0];
              console.log(wellKnownName)
               // Set custom SVG icon based on the wellKnownName
              let svgIcon = null;
              switch (wellKnownName) {
                case 'circle':
                  svgIcon = L.divIcon({
                    className: 'custom-marker',
                    html: `<svg width="12" height="12" viewBox="0 0 12 12"><circle cx="6" cy="6" r="5" fill="${svgParameterFill.textContent}" stroke="${svgParameterStroke.textContent}" stroke-width="1"/></svg>`
                  });
                  break;
                case 'square':
                  svgIcon = L.divIcon({
                    className: 'custom-marker',
                    html: `<svg width="12" height="12" viewBox="0 0 12 12"><rect x="1" y="1" width="10" height="10" fill="${svgParameterFill.textContent}" stroke="${svgParameterStroke.textContent}" stroke-width="1"/></svg>`
                  });
                  break;
                // Add cases for other well known names if needed
              }

              // If custom SVG icon is defined, set it in the defaultStyle
              if (svgIcon) {
                defaultStyle.icon = svgIcon;
              }
            }
            break; // Exit loop if rule matched
          }
        }
        
        return defaultStyle;
      };
    },
    async parseQMLFile(qmlContent) {
    
       
        console.log(qmlContent)
        const qgisParser = new QGISStyleParser();
       
        const parsedStyles =await qgisParser.readStyle(qmlContent);
        console.log(parsedStyles)
        //this.parsedStyles = parsedStyles;
   
    },
    parseQMLStyles(qmlContent) {
      const parser = new DOMParser();
      const qmlFileObject = parser.parseFromString(qmlContent, "text/xml");

      const rules = qmlFileObject.querySelectorAll('rule');
      const symbols = qmlFileObject.querySelectorAll('symbol');

      const parsedRules = [];

      rules.forEach(rule => {
        const label = rule.getAttribute('label');
        const symbolId = rule.getAttribute('symbol');
        const filter = rule.getAttribute('filter');

        const symbol = Array.from(symbols).find(symbol => symbol.getAttribute('name') === symbolId);
        
        const symbolProperties = symbol ? {
          type: symbol.getAttribute('type'),
          layerClass: symbol.querySelector('layer').getAttribute('class'),
          color: symbol.querySelector('Option[name="color"]') ? symbol.querySelector('Option[name="color"]').getAttribute('value'):symbol.querySelector('Option[name="line_color"]').getAttribute('value'),
          border_width: symbol.querySelector('Option[name="border_width"]')?symbol.querySelector('Option[name="border_width"]').getAttribute('value') : null ,
          outline_color:symbol.querySelector('Option[name="outline_color"]')? symbol.querySelector('Option[name="outline_color"]').getAttribute('value'):null,
          outline_width:symbol.querySelector('Option[name="outline_width"]')? symbol.querySelector('Option[name="outline_width"]').getAttribute('value'):null
        } : null;

        parsedRules.push({
          label,
          symbol: symbolProperties,
          filter
        });
      });
      console.log('parsedRules',parsedRules)
      return parsedRules;
    },
        setsidebarMap(){
      //console.log(this.sidebar_settings)
      this.$store.commit('set', ['sidebarMap', this.sidebar_settings])
    },
    change_search(){
      this.searchByName(this.search_value);
    },
    searchByName(searchStr) {
    searchStr = searchStr.toLowerCase(); // Convert search string to lowercase for case-insensitive search
    //console.log(this.poi_data)
    
    this.searchResults = this.cemeteries_points_table.filter(item => item.ids.toString().toLowerCase().includes(searchStr));
    console.log(searchStr)
    },
    flyToMarker(marker){
      console.log(marker)
      var point_lat_lon=JSON.parse(marker.geom)
      this.$refs.map1.mapObject.flyTo([point_lat_lon.coordinates[1],point_lat_lon.coordinates[0]],18).once('moveend', () => {
      // This callback is called when the flyTo animation ends
      console.log('FlyTo animation finished');

      // Call loadchurch() method from the ParcelsPoly component after animation
      if (this.$refs.parcelsPoly) {
        this.$refs.parcelsPoly.loadchurch();
      }
    });
     
      
    },
    generateUniqueColor(existingColors) {
      let newColor;

      do {
        newColor = '#' + Math.floor(Math.random() * 16777215).toString(16);
      } while (existingColors.includes(newColor));

      return newColor;
    },
    openPdfEntipa(station,folder){
      var str_id
      
      if(station.ids<10){
        str_id='00'+station.ids
      }else if(9<station.ids && station.ids<100){
        str_id='0'+station.ids
      }else{
        str_id=station.ids
      }

      var name=str_id+'_'+folder+'.pdf'
      //name='p13.pdf'
      this.openPdf(name,folder)
      console.log(name)
    },
    openPdf(name,folder){
      var v=this
      this.tst=true
      var token=localStorage.getItem('token')
      axios_django
            .get("cemeteryzak/view_pdf/", { params: { name: name,folder:folder }, responseType: "blob",headers: {Authorization: `Bearer ${token}`} })
            .then((response) => {
              //Create a Blob from the PDF Stream
              ////console.log(name.includes('.jpg'))
              var type;
              type = !name.includes('.jpg') ? "application/pdf": 'image/jpeg';
              
              ////console.log(name)
              const file = new Blob(
                [response.data],
                //{type: 'application/pdf'});
                { type: type }
              );
              ////console.log(file)
              //Build a URL from the file

              const fileURL = URL.createObjectURL(file);
              //Open the URL on new Window

              window.open(fileURL);
              
              v.tst=false
            });
    },
    tableToMarker(item){
      //console.log(item)
      this.flyToMarker(item)
    },
    zoomUpdate(zoom){
      //console.log(zoom)
      this.live_zoom=zoom
    },
    Logout(){
      localStorage.clear()
      this.$router.push('/')
    },
    addDiktiaYdreusis(){
      if(this.show_diktia_ydreusis){
        this.selected_radio_group=null
        this.show_diktia_ydreusis_tabs=false     
        this.show_tabs =false     
      }else{
        this.selected_radio_group='geolocation'  
        this.show_diktia_ydreusis_tabs=false     
        this.show_tabs =false     

      }
    }
    
  
  }
 

};
</script>

<style >

.tree-default .tree-node {
    margin-left: 10px!important;
}
.tree-default .tree-wholerow-clicked {
    background: '#fff0'!important;
}
.tree-default .tree-disabled > .tree-icon {
   opacity: 1!important;
  filter: 0 !important;
  filter: rgba(128, 128, 128, 0) !important;
  -webkit-filter: grayscale(0%) !important;
}
.tree-default .tree-disabled{
  color:inherit!important;
}

.tree-default .tree-disabled > .tree-checkbox {
  opacity: 0.05!important;
}
.tree-default .tree-wholerow-clicked {
    background: #fff0!important;
}
.tree-wholerow-hovered{
  background: #fff0!important;
}
.bottomleft-control {
  background: #6c757d;
    border-radius: 0 20px 0 0;
    box-shadow: 0 0 3rem rgb(0 0 0/45%)!important;
}
.logo-perifereia {
  width: 20vh;
}
.chart-div{
  border-radius: 20px 0 0 0;
  box-shadow: 0 0 3rem rgb(0 0 0/45%)!important;
  width:35%;
}
.btn-settings{
  border-radius: 0 20px 20px 0!important;
  box-shadow: 0 0 3rem rgb(0 0 0/45%)!important;
}
.legend-div{
  position:absolute;
  bottom:8px;
  right:5px;
  z-index: 1001;
}
@media screen and (max-width: 730px) {
  .chart-div{
    border-radius: 0 0 0 0;
    box-shadow: 0 0 3rem rgb(0 0 0/45%)!important;
    width:100%;
  }
  .logo-perifereia {
  width: 15vh;
}

.card-body {
   
    padding: 0.4rem!important;
}
}
hr {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
/*.tree-children{
  padding:10px!important;
}*/

::-webkit-scrollbar {
    width: 5px;
    height:5px
}
::-webkit-scrollbar-thumb {
    background: #07a4ff;
    border-radius: 20px;
}
::-webkit-scrollbar-track {
    background-color: #9e9e9e;
    border-radius: 20px;    
}
.leaflet-control{
  background:#003b5dbf!important;
  border-radius:20px;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 5px 15px;
  padding:10px;
  color:white
}
.leaflet-touch .leaflet-bar a{
  background: #fff0!important;
  color: #fff;
  width: 25px;
  height: 25px;

}
.leaflet-touch .leaflet-control-layers, .leaflet-touch .leaflet-bar {
    border: 0px solid rgba(0,0,0,0.2)!important;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 5px 15px;
}
.leaflet-touch .leaflet-control-layers-toggle {
    width: 30px;
    height: 30px;
}
.leaflet-control-geosearch a.leaflet-bar-part:after {
    top: 16px;
    left: 16px;
    height: 14px;
    width: 14px;
    border-radius: 50%;
    border: 2px solid #fff;
}
.leaflet-control-geosearch a.leaflet-bar-part:before {
    top: 29px;
    left: 26px;
    width: 8px;
    border-top: 2px solid #fff;
    transform: rotateZ(45deg);
    
}
.fa-map-marker{
  font-size:20px;
  color:#fff
}
.leaflet-tooltip-own{
  background:#ffffff30;
  border: 0px solid #ffffff30;
}
.leaflet-tooltip-top:before,
.leaflet-tooltip-bottom:before,
.leaflet-tooltip-left:before,
.leaflet-tooltip-right:before {
    position: absolute;
    pointer-events: none;
    border: 6px solid transparent;
    background: transparent;
    content: "";
    }

.geosearch{
  color:black;
  z-index:9000;
}
.col-lg-12{
  padding-right: 0px!important;
  padding-left: 0px!important;
}
.col-lg-6{
  padding-right: 0px!important;
  padding-left: 0px!important;
}
.col-lg-7{
  padding-right: 0px!important;
  padding-left: 0px!important;
}
.col-lg-5{
  padding-right: 0px!important;
  padding-left: 0px!important;
}



.gradient-box {
  
  background: linear-gradient(45deg, #810170, #001691, rgb(0, 100, 95)); /* Initial gradient colors */
  background-size: 600% 600%;
  animation: changeGradient 20s infinite;
}

@keyframes changeGradient {
  0% {
    background-position: 0% 50%; /* Initial position */
  }
  50% {
    background-position: 100% 50%; /* Final position */
  }
  100% {
    background-position: 0% 50%; /* Back to initial position */
  }
}
.leaflet-popup-content-wrapper, .leaflet-popup-tip{
  width: 220px;
}
.table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
    text-align: left!important;;
}
.modal-dialog {
    max-width: 90%;
    margin-top: 0;
    margin-bottom: 0;
    top: 0;
    bottom: 0;
    
    height: 100vh;
    display: flex;
}
</style>



<!--
  {
                "text": "M.A. θερμών ημερών 1981-2000",
                "description":"Μέσος αριθμός πολύ θερμών ημερών (>35°C) την περίοδο αναφοράς (1981-2000)",
                "type_of_data":"geojson",
                "loaded":false,
                "data_column":"Be46",
                "value":[{"api":"pespka/klimatikes_allages/","params": {"db_name":"be46"}}],
                "legend":{"tooltip":{"show":true,"tooltip_column":"mean","permanent":true},"column":"mean", "value":[[0,114],[114,117],[117,124],[124,130],[130,132]],"color":["#ffcccc","#ff9e8f","#fa725a","#ed432d","#db0000"],"text":["0-113","114-117","118-124","125-130","131-132"],"title":"Μέσος αριθμός πολύ θερμών ημερών (>35°C) την περίοδο αναφοράς (1981-2000)","weight":0.5,"weight_color":"black"}
            },
-->